import { parsePhoneNumberFromString } from 'libphonenumber-js';

export default (context, inject) => {
  const phone = (value) => {
    return parsePhoneNumberFromString(value.toString(), 'IE').formatNational();
  };

  inject('phone', phone);
  context.$phone = phone;
};
